'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminPrompt = undefined;

var _Promptable = require('UIComponents/decorators/Promptable');

var _Promptable2 = _interopRequireDefault(_Promptable);

var _AdminModal = require('ui-addon-upgrades/_core/common/components/AdminModal');

var _AdminModal2 = _interopRequireDefault(_AdminModal);

var _PromiseHandlers = require('UIComponents/core/PromiseHandlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _prompt = (0, _Promptable2.default)(_AdminModal2.default);

var AdminPrompt = exports.AdminPrompt = function AdminPrompt(propsToPass) {
  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/components/AdminPrompt.js
// module id = 508
// module chunks = 3 4 5